
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buero/publikationen",
      function () {
        return require("private-next-pages/buero/publikationen/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buero/publikationen"])
      });
    }
  